const config = {
  'development': {
    webHost: 'localhost:3003',
  },
  'production': {
    webHost: 'xpart.in.ua',
  },
}

export const getConfig = () => {
  return config[process.env.REACT_APP_ENV] || {}
}